import moment from 'moment';
import { appMenuGroups } from 'router/router';

//export const userpilotDomain = `(${window.location?.hostname}/${localStorage.getItem('userRole')})`;
export const userpilotDomain = (userRole:any) => {
  return `(${window.location?.hostname}/${userRole})`;
}

export const createArrayNumber = (numberLength: number) => {
  return Array.from({ length: numberLength }, (_, i) => ({ value: i + 1 }));
};

export const isNotEmpty = (str: String) => {
  return str.length !== 0 && !!str;
};

export const removeDuplicate = (data: any[]) => {
  return Array.from(new Set(data));
};

export const getArrayYears = (fromDate: any, toDate: any) => {
  let yearsTemp = [];
  const fromYear = formatDate(fromDate, 'yyyy');
  const toYear = formatDate(toDate, 'yyyy');
  let numFromYear = Number(fromYear);
  const numToYear = Number(toYear);
  while (numFromYear <= numToYear) {
    yearsTemp.push(numFromYear);
    numFromYear++;
  }
  return yearsTemp;
}

export const checkDecimalInRange = (num: any) => {
  const numStr = String(num);
  if (numStr.includes('.')) {
    return numStr.split('.')[1].length <= 5;
  }
  return true;
};

export const setArrayLength = (arr: any[], lengthInput: number | string, defaultModal?: any) => {
  const length = Number(lengthInput);
  const data = [...(arr ?? [])].filter((item, index) => index < length);
  if (data.length < length) {
    const newData = [...data, ...Array(length - data.length)].map((item) =>
      !item ? defaultModal ?? {} : item
    );
    return newData;
  }
  return data;
};
export const checkEnableParseJSON: any = (data: string, undefinedReturn?: any) => {
  if (data === undefined || data === null || typeof data !== 'string') {
    return undefinedReturn ?? null;
  } else if (
    data?.includes(`{"`) ||
    data?.includes(`[`) ||
    data?.includes(`[]`) ||
    data?.includes(`{}`)
  ) {
    return JSON.parse(data);
  } else {
    return undefinedReturn ?? null;
  }
};
export const tryParseJSON: any = (data: string, undefinedReturn?: any) => {
  if (data === undefined || data === null || typeof data !== 'string') {
    return undefinedReturn ?? null;
  }

  try {
    return JSON.parse(data);
  }
  catch (ex) {
    return undefinedReturn ?? null;
  }
};
export const isEmptyObject = (obj:any) => {
  return Object.keys(obj).length === 0
}
export const isEmptyArrayObject = (obj:any) => {
  if (Array.isArray(obj)) {
    if (obj.length===1) {
      return  Object.keys(obj[0]).length === 0;
    }
    return false;
  }
  return Object.keys(obj).length === 0;
}

export const isNullOrUndefined = (value: any) => {
  return (value === null || value === undefined);
}
export const isEmptyOrNull = (value: any) => {
  return (value === null || value === undefined || value ==='');
}

export const paserSubjectFirst: any = (data: string) => {
  const subject = data.substring(1); // Extract subject early

  switch (subject) {
    case '1 - Biological Science':
      return { startLetter: 'D1', subject };
    case '1 Biological Science':
      return { startLetter: 'D1', subject };
    case '2 - Physical Science':
      return { startLetter: 'D2', subject };
    case '2 Physical Science':
      return { startLetter: 'D2', subject };
    default:
      return { startLetter: data.slice(0, 1).toUpperCase(), subject };
  }
};

export const checkTypeOfClassDualEnrollment: any = (typeOfClass: any, isTakeClassAtCollege: any) => {
  if (typeOfClass === undefined || typeOfClass === null || typeOfClass === '') {
    return false;
  } else {
    const typeOfClassLower = typeOfClass.toLowerCase();
    if (
      typeOfClassLower.includes('dual enrollment') && isTakeClassAtCollege === true
    ) {
      return true;
    } else {
      return false;
    }
  }
}

export const checkExistKey: any = (data: any, valueKey: string) => {
  Object.entries(data).map(([key, value]) => {
    if (key + '' === valueKey) {
      return value;
    }
  });
  return null;
}

export const checkEmptyValue: any = (data: any) => {
  if (data === undefined || data === null || data === '' || data === 0 || data === " ") {
    return true;
  }
  return false;
};

export const checkSubjectMap: any = (subjectValue: any) => {
  for (const [key, value] of Object.entries(collegeCourseMapSubjectArea)) {
    if (value.includes(subjectValue)) {
      return key;
    }
  }
}

export const checkTypeOfClass: any = (typeOfClass: any, condition: any) => {
  if (typeOfClass === undefined || typeOfClass === null || typeOfClass === '') {
    return false;
  } else {
    if (typeOfClass === condition) {
      return true;
    }
    else {
      return false;
    }
  }
}

export const isSemesterOn: any = (isSemester: any) => {
  // Check if isSemester is a 'on'
  if (isSemester !== undefined && isSemester !== null) {
    if (isSemester.length > 0 && isSemester[0] === 'on') {
      return true;
    } else if (isSemester === true) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}

export const getKeyTypeOfCourse: any = (typeOfCourse: any) => {
  if (typeOfCourse === 'Advanced Placement (AP)') {
    return 'AP';
  } else if (typeOfCourse === 'International Baccalaureate (IB)') {
    return 'IB';
  } else if (typeOfCourse === 'Transferable College Courses') {
    return 'TC';
  } else if (typeOfCourse === 'Weighted Honors Courses') {
    return 'WH';
  } else {
    return null;
  }
}

export const checkWeightedCourse: any = (weightedCourse: any) => {
  if (!checkEmptyValue(weightedCourse) && weightedCourse === 'Yes') {
    return true;
  }
  return false;
}

// Check if the grade is a number or a string (For Grade Scale 1-100)
export const checkNoCreditEligible: any = (gradeValue: any) => {
  if (typeof gradeValue === 'number') {
    return gradeValue >= 0 && gradeValue <= 69; // Kiểm tra điểm số bằng số
  } else if (typeof gradeValue === 'string') {
    const nonCreditGrades = [
      'Incomplete',
      'No Grade',
      'Fail - (Pass/Fail)',
      'U- Unsatisfactory',
      // 'Withdrawn',
      'Withdrawn - Failed',
      'Medical Excuse',];
    return nonCreditGrades.includes(gradeValue); //Kiểm tra điểm chữ
  } else {
    return false; // Trường hợp grade hợp lệ
  }

}

//check if the grade is a string (For Grade Scale A-F)
export const checkNoCreditAwarded: any = (gradeValue: any) => {
  const notCreditAwarded = [
    'D+',
    'D',
    'D-',
    // 'E',
    'F',
    'Incomplete',
    'No Grade',
    // 'Fail - (Pass/Fail)',
    // 'Pass - (Pass/Fail)',
    // 'S - Satisfactory',
    'U- Unsatisfactory',
    'Withdrawn',
    'Withdrawn - Failed',
    'Medical Excuse',];
  if (notCreditAwarded.includes(gradeValue)) {
    return true;
  }
  return false;
}

export const checkNoCreditGradeCollege: any = (gradeValue: any) => {
  const gradeArray = ['D+', 'D', 'D-', 'F', 'NP', 'NC', 'WI', 'WF', 'WU', 'IN'];
  if (gradeArray.includes(gradeValue)) {
    return true;
  }
  return false;
}

export const getPointYearFromSchedule: any = (scheduleValue: any) => {
  if (scheduleValue === 'Semester') {
    return 0.5;
  } else if (scheduleValue === 'Quarters') {
    return 0.25;
  } else if (scheduleValue === 'Trimester') {
    return 0.333;
  } else if (scheduleValue === 'Yearly') {
    return 1;
  } else {
    return 0;
  }
}

export const checkThreeTrimester = (pointValue: any) => {
  if (pointValue === 0.9990000000000001) {
    return true;
  }
  return false;
}

export const renderDate = (data: any) => {
  return moment(data).isValid() ? moment(data).format('MM/DD/yyyy') : '';
};
export const countWordInString = (string: string) => {
  const spaces = (string || '').trim().replace(/\s+/g, ' ').split(' ').length;
  return isNaN(spaces) ? 0 : spaces;
};

export async function base64toBlob(base64Data: string, contentType?: any) {
  contentType = contentType || '';
  const sliceSize = 1024;
  const byteCharacters = btoa(unescape(encodeURIComponent(base64Data)));
  const bytesLength = byteCharacters.length;
  const slicesCount = Math.ceil(bytesLength / sliceSize);
  const byteArrays = new Array(slicesCount);
  for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
    const begin = sliceIndex * sliceSize;
    const end = Math.min(begin + sliceSize, bytesLength);

    const bytes = new Array(end - begin);
    for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
      bytes[i] = byteCharacters[offset].charCodeAt(0);
    }
    byteArrays[sliceIndex] = new Uint8Array(bytes);
  }
  return new Blob(byteArrays, { type: contentType });
}

export function FileToBase64(file: any) {
  const reader: FileReader = new FileReader();
  return new Promise((resolve: Function, reject: Function) => {
    reader.onerror = () => {
      reader.abort();
      reject(new Error('Error parsing file'));
    };
    reader.readAsBinaryString(file);
    reader.onloadend = () => {
      resolve(reader.result);
    };
    // reader.readAsArrayBuffer(file);
  });
}
export const optionValues = (options: any[]) => {
  const returnValues: { value: number }[] = options.map((opt) => {
    return { value: Number(opt) };
  });
  return returnValues;
};

export const optionValues2 = (length: number, start?: number, step?: number) => {
  const returnValues: { value: number }[] = Array.from(Array(length).keys()).map((opt) => {
    return { value: Number(opt + (start ?? 0)) * (step ?? 1) };
  });
  return returnValues;
};
export const optionStringValues = (options: any[]) => {
  const returnValues: { value: string }[] = options.map((opt) => {
    return { value: `${Number(opt)}` };
  });
  return returnValues;
};

export const optionFromArray = (arr: string[]) => {
  const res = arr.map((str) => {
    return { value: str.trim() };
  });
  return res;
};
export const capitalizeFirstLetter = (string: string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const checkCouserNameIncludes = (courseName: string, agSubjectAreaValue: string) => {
  switch (agSubjectAreaValue) {
    case 'D2':
      return couserNameIncludesD2.filter((item) => courseName.includes(item));
    default:
      return [];
  }
}

export const formatYearRange = (input?: string | String) => {
  if (!input) return '';
  return input.replace(/\s*-\s*/g, '-').trim();
}

export const agSubjectAreaValues: any = {
  'A': 'A History / Social Science',
  'B': 'B English',
  'C': 'C Mathematics',
  'D1': 'D1 Biological Science',
  'D2': 'D2 Physical Science',
  'E': 'E Language Other Than English',
  'F': 'F Visual & Performing Arts',
  'G': 'G College-Preparatory Elective',
};

export const finishYearOption = [
  { value: 2025 },
  { value: 2026 },
  { value: 2027 },
  { value: 2028 },
  { value: 2029 },
  { value: 2030 },
];

export const PrefixOptions = [
  {
    value: ' ',
  },
  {
    value: 'Mr.',
  },
  {
    value: 'Mrs.',
  },
  {
    value: 'Ms.',
  },
];

export const suffixOptions = [
  {
    value: ' ',
  },
  {
    value: 'Jr',
  },
  {
    value: 'Sr',
  },
  {
    value: 'II',
  },
  {
    value: 'III',
  },
  {
    value: 'IV',
  },
];
export const fullSuffixOptions = [
  ' ',
  'Jr.',
  'Sr.',
  'II',
  'III',
  'IV',
  'V',
  'VI',
  'VII',
  'VIII',
  'IX',
  'X',
];
export const couserNameIncludesD2 = [
  'Chemistry',
  'Physics'
];
export const jobCategory = [
  'Accounting',
  'Admin & Clerical',
  'Automotive',
  'Banking',
  'Biotech',
  'Broadcast Journalism',
  'Business Development',
  'Construction',
  'Consultant',
  'Customer Service',
  'Design',
  'Distribution - Shipping',
  'Education - Teaching',
  'Engineering',
  'Entry Level - New Grad',
  'Executive',
  'Facilities',
  'Finance',
  'Franchise',
  'General Business',
  'General Labor',
  'Government',
  'Grocery',
  'Health Care',
  'Hotel - Hospitality',
  'Human Resources',
  'Information Technology',
  'Installation - Maint - Repair',
  'Insurance',
  'Inventory',
  'Legal',
  'Legal Admin',
  'Management',
  'Manufacturing',
  'Marketing',
  'Media - Journalistm - Newspaper',
  'Nonprofit - Social Services',
  'Nurse',
  'Pharmaceutical',
  'Professional Services',
  'Purchasing - Procurement',
  'QA - Quality Control',
  'Real Estate',
  'Research',
  'Restaurant - Food Service',
  'Retail',
  'Sales',
  'Science',
  'Skilled Labor - Trades',
  'Strategy - Planning',
  'Supply Chain',
  'Telecommunications',
  'Training',
  'Transportation',
  'Warehouse',
  'Other',
];
export const strongPasswordRegexp = new RegExp(
  '(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})'
);
export const mediumPasswordRegexp = new RegExp(
  '((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{6,}))|((?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9])(?=.{8,}))'
);

export const dateFormat = 'MM/DD/yyyy';
export const monthFormat = 'MM/yyyy';

export function getMonthNumberFromName(monthName: String) {
  return !monthName.length ? '' : new Date(`${monthName} 1, 2022`).getMonth() + 1;
}

export const formatDate = (values: any, format?: string) => {
  if (!values || values === null) return '-';
  const returnValues = moment(values).format(format ?? dateFormat);
  return moment(values).isValid() ? returnValues : '-';
};

export const formatMonth = (values: any) => {
  if (values === null) return '-';
  const returnValues = moment(values).format('MM/yyyy');
  return moment(values).isValid() ? returnValues : '-';
};

export const formatBoolean = (values: any) => {
  if (values === 'true') return true;
  if (values === 'false') return false;
  if (typeof values == "boolean") return values;
  return undefined;
};
export const BoolToString = (values: any) => {
  if (values === true) return 'true';
  if (values === false) return 'false';
  if (values === 'true') return 'true';
  if (values === 'false') return 'false';
  return '';
};

export const monthOptions = [
  { value: '', name: '- Select -' },
  { value: 'January', name: 'January' },
  { value: 'February', name: 'February' },
  { value: 'March', name: 'March' },
  { value: 'April', name: 'April' },
  { value: 'May', name: 'May' },
  { value: 'June', name: 'June' },
  { value: 'July', name: 'July' },
  { value: 'August', name: 'August' },
  { value: 'September', name: 'September' },
  { value: 'October', name: 'October' },
  { value: 'November', name: 'November' },
  { value: 'December', name: 'December' },
];
export const dayOptions = [
  { value: '', name: '- Select -' },
  { value: '1', name: '1' },
  { value: '2', name: '2' },
  { value: '3', name: '3' },
  { value: '4', name: '4' },
  { value: '5', name: '5' },
  { value: '6', name: '6' },
  { value: '7', name: '7' },
  { value: '8', name: '8' },
  { value: '9', name: '9' },
  { value: '10', name: '10' },
  { value: '11', name: '11' },
  { value: '12', name: '12' },
  { value: '13', name: '13' },
  { value: '14', name: '14' },
  { value: '15', name: '15' },
  { value: '16', name: '16' },
  { value: '17', name: '17' },
  { value: '18', name: '18' },
  { value: '19', name: '19' },
  { value: '20', name: '20' },
  { value: '21', name: '21' },
  { value: '22', name: '22' },
  { value: '23', name: '23' },
  { value: '24', name: '24' },
  { value: '25', name: '25' },
  { value: '26', name: '26' },
  { value: '27', name: '27' },
  { value: '28', name: '28' },
  { value: '29', name: '29' },
  { value: '30', name: '30' },
  { value: '31', name: '31' },
];

export const yearOptions = [
  { value: '',  name: '- Select -' },
  ...Array.from({ length: (new Date().getFullYear() + 1) - 1900 + 1 }, (_, i) => ({
    value: (new Date().getFullYear() + 1) - i,
    name: (new Date().getFullYear() + 1) - i
  })),
];

export const occupationOptions = [
  { value: 'Choose an option' },
  { value: 'Accountant or actuary' },
  { value: 'Actor or entertainer' },
  { value: 'Architect or urban planner' },
  { value: 'Artist' },
  { value: 'Business (clerical)' },
  { value: 'Business executive (management, administrator)' },
  { value: 'Business owner or proprietor' },
  { value: 'Business salesperson or buyer' },
  { value: 'Clergy (minister, priest)' },
  { value: 'Clergy (other religious)' },
  { value: 'Clinical Psychologist' },
  { value: 'College Administrator/staff' },
  { value: 'College Teacher' },
  { value: 'Computer programmer or analyst' },
  { value: 'Conservationist or forester' },
  { value: 'Dentist (including orthodontist)' },
  { value: 'Dietitian or nutritionist' },
  { value: 'Engineer' },
  { value: 'Farmer or rancher' },
  { value: 'Foreign service worker (including diplomat)' },
  { value: 'Homemaker (full-time)' },
  { value: 'Interior decorator (including designer)' },
  { value: 'Lab technician or hygienist' },
  { value: 'Laborer' },
  { value: 'Law enforcement officer' },
  { value: 'Lawyer (attorney) or judge' },
  { value: 'Military service (career)' },
  { value: 'Musician (performer, composer)' },
  { value: 'Nurse' },
  { value: 'Optometrist' },
  { value: 'Pharmacist' },
  { value: 'Physician' },
  { value: 'Policymaker/Government' },
  { value: 'School Counselor' },
  { value: 'School principal or superintendent' },
  { value: 'Scientific researcher' },
  { value: 'Skilled trades' },
  { value: 'Social' },
  { value: 'Welfare, or recreation worker' },
  { value: 'Teacher or administrator (elementary)' },
  { value: 'Teacher or administrator (secondary)' },
  { value: 'Therapist (physical, occupational, speech)' },
  { value: 'Veterinarian' },
  { value: 'Writer or journalist' },
  { value: 'Other' },
];

export const educationLevelOptions = [
  { value: 'None' },
  { value: 'Some High School or Less' },
  { value: 'High School Diploma/GED' },
  { value: 'Some College/No Degree Earned' },
  { value: `Two-year associate's degree` },
  { value: "Bachelor's Degree" },
  { value: `Master's Degree` },
  { value: 'Professional Degree (MBA, MD, JD, etc.)' },
  { value: 'Doctorate Degree or Higher' },
  { value: 'Unknown' },
];
export const siblingEducationOptions = [
  'None',
  'Some grade/primary school',
  'Completed grade/primary school',
  'Some high/secondary school',
  'Graduated from high/secondary school (or equivalent)',
  'Some trade school or community college',
  'Graduated from trade school or community college',
  'Some college/university',
  'Graduated from college/university',
  'Graduate school',
];
export const progressionHighSchool = [
  { value: 'progression_is_graduate_early', label: 'Did or will graduate early' },
  { value: 'progression_is_graduate_late', label: 'Did or will graduate late' },
  { value: 'progression_is_time_off', label: 'Did or will take time off' },
  { value: 'progression_is_take_gap_year', label: 'Did or will take gap year' },
  { value: 'progression_is_no_change', label: 'No change in progression' },
];

export const schoolGradingScaleOptions = [
  { value: 'grading_scale_is_abcdf', label: 'A B C D F' },
  { value: 'grading_scale_is_0_100', label: '0-100(U.S.)' },
  { value: 'grading_scale_is_1_7', label: "1-7 Int'l Bacc" },
  { value: 'grading_scale_is_other', label: 'Other' },
];

export const findNextRoute = (pathname: string, sectionPermissionDenied: string[]): string => {
  const parseMenuRoute = appMenuGroups.map((item: any) => {
    return {
      ...item,
      pathIncludes: item.isGroup ? item.children.map((i: any) => i.path) : [],
    };
  });
  const readyRoute = parseMenuRoute
    .find((e: any) => e.pathIncludes.includes(pathname))
    .children.filter((child: any) => !sectionPermissionDenied.includes(child?.name));
  const currentIndex = readyRoute.findIndex((route: any) => route.path === pathname);
  return readyRoute[currentIndex + 1].path as string;
};

export const reorder: (
  list: Iterable<unknown> | ArrayLike<unknown>,
  startIndex: number,
  endIndex: number
) => any[] = (
  list: Iterable<unknown> | ArrayLike<unknown>,
  startIndex: number,
  endIndex: number
) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

export const tribalEnrollmentOptions = [
'AK - Afognak',
'AK - Agdaagux',
'AK - Akhiok',
'AK - Akiachak',
'AK - Akiak',
'AK - Akutan',
'AK - Alakanuk',
'AK - Alatna',
'AK - Aleknagik',
'AK - Algaaciq',
'AK - Allakaket',
'AK - Alutiiq Tribe of Old Harbor',
'AK - Ambler',
'AK - Anaktuvuk Pass',
'AK - Andreafski',
'AK - Angoon',
'AK - Aniak',
'AK - Anvik',
'AK - Arctic Village',
'AK - Asa\'carsarmiut',
'AK - Atka',
'AK - Atmautluak',
'AK - Atqasuk',
'AK - Barrow',
'AK - Beaver',
'AK - Belkofski',
'AK - Bill Moore\'s Slough',
'AK - Birch Creek',
'AK - Brevig Mission',
'AK - Buckland',
'AK - Cantwell',
'AK - Chalkyitsik',
'AK - Cheesh-Na',
'AK - Chefornak',
'AK - Chenega',
'AK - Chevak',
'AK - Chickaloon',
'AK - Chignik Bay',
'AK - Chignik Lagoon',
'AK - Chignik Lake',
'AK - Chilkat',
'AK - Chilkoot',
'AK - Chinik',
'AK - Chitina',
'AK - Chuathbaluk',
'AK - Chuloonawick',
'AK - Circle',
'AK - Clark\'s Point',
'AK - Council',
'AK - Craig',
'AK - Crooked Creek',
'AK - Curyung',
'AK - Deering',
'AK - Diomede',
'AK - Dot Lake',
'AK - Douglas',
'AK - Eagle',
'AK - Eek',
'AK - Egegik',
'AK - Eklutna',
'AK - Ekuk',
'AK - Ekwok',
'AK - Elim IRA',
'AK - Emmonak',
'AK - Evansville',
'AK - Eyak',
'AK - False Pass',
'AK - Fort Yukon',
'AK - Gakona',
'AK - Gambell',
'AK - Georgetown',
'AK - Goodnews Bay',
'AK - Grayling',
'AK - Gulkana',
'AK - Hamilton',
'AK - Healy Lake',
'AK - Holy Cross',
'AK - Hoonah',
'AK - Hooper Bay',
'AK - Hughes',
'AK - Huslia',
'AK - Hydaburg',
'AK - Igiugig',
'AK - Iliamna',
'AK - Inupiat Community of the Arctic Slope',
'AK - Iqugmiut',
'AK - Ivanof Bay Tribe',
'AK - Kaguyuk',
'AK - Kake',
'AK - Kaktovik',
'AK - Kalskag',
'AK - Kaltag',
'AK - Kanatak',
'AK - Karluk',
'AK - Kasaan',
'AK - Kasigluk',
'AK - Kenaitze',
'AK - Ketchikan',
'AK - Kiana',
'AK - King Island',
'AK - King Salmon',
'AK - Kipnuk',
'AK - Kivalina',
'AK - Klawock',
'AK - Kluti-Kaah',
'AK - Knik',
'AK - Kobuk',
'AK - Kokhanok',
'AK - Kongiganak',
'AK - Kotlik',
'AK - Kotzebue',
'AK - Koyuk',
'AK - Koyukuk',
'AK - Kwethluk',
'AK - Kwigillingok',
'AK - Kwinhagak',
'AK - Larsen Bay',
'AK - Levelock',
'AK - Lime',
'AK - Louden',
'AK - Lower Kalskag',
'AK - Manley Hot Springs',
'AK - Manokotak',
'AK - Marshall',
'AK - Mary\'s Igloo',
'AK - Mcgrath',
'AK - Mekoryuk',
'AK - Mentasta',
'AK - Metlakatla',
'AK - Minto',
'AK - Naknek',
'AK - Nanwalek',
'AK - Napaimute',
'AK - Napakiak',
'AK - Napaskiak',
'AK - Nelson Lagoon',
'AK - Nenana',
'AK - New Koliganek',
'AK - New Stuyahok',
'AK - Newhalen',
'AK - Newtok',
'AK - Nightmute',
'AK - Nikolai',
'AK - Nikolski',
'AK - Ninilchik',
'AK - Noatak',
'AK - Nome',
'AK - Nondalton',
'AK - Noorvik',
'AK - Northway',
'AK - Nuiqsut',
'AK - Nulato',
'AK - Nunakauyarmiut',
'AK - Nunam Iqua',
'AK - Nunapitchuk',
'AK - Ohogamiut',
'AK - Orutsararmiut',
'AK - Oscarville',
'AK - Ouzinkie',
'AK - Paimiut',
'AK - Pauloff Harbor',
'AK - Pedro Bay',
'AK - Perryville',
'AK - Petersburg',
'AK - Pilot Point',
'AK - Pilot Station',
'AK - Pitka\'s Point',
'AK - Platinum',
'AK - Point Hope IRA',
'AK - Point Lay IRA',
'AK - Port Graham',
'AK - Port Heiden',
'AK - Port Lions',
'AK - Portage Creek',
'AK - Qagan Tayagungin',
'AK - Qawalangin',
'AK - Rampart',
'AK - Red Devil',
'AK - Ruby',
'AK - Saint Paul',
'AK - Salamatof',
'AK - Savoonga',
'AK - Saxman',
'AK - Scammon Bay',
'AK - Selawik',
'AK - Seldovia',
'AK - Shageluk',
'AK - Shaktoolik',
'AK - Shishmaref IRA',
'AK - Shungnak',
'AK - Sitka',
'AK - Skagway',
'AK - Sleetmute',
'AK - Solomon',
'AK - South Naknek',
'AK - St. George',
'AK - St. Michael IRA',
'AK - Stebbins',
'AK - Stevens Village',
'AK - Stony River',
'AK - Sun\'aq',
'AK - Takotna',
'AK - Tanacross',
'AK - Tanana',
'AK - Tangirnaq',
'AK - Tatitlek',
'AK - Tazlina',
'AK - Telida',
'AK - Teller',
'AK - Tetlin',
'AK - Tlingit & Haida',
'AK - Togiak',
'AK - Tuluksak',
'AK - Tuntutuliak',
'AK - Tununak',
'AK - Twin Hills',
'AK - Tyonek',
'AK - Ugashik',
'AK - Umkumiut',
'AK - Unalakleet',
'AK - Unga',
'AK - Venetie',
'AK - Venetie IRA',
'AK - Wainwright',
'AK - Wales',
'AK - White Mountain AK',
'AK - Wrangell',
'AK - Yakutat',
'AL - Poarch',
'AZ - Ak Chin',
'AZ - Cocopah',
'AZ - Colorado River',
'AZ - Fort McDowell',
'AZ - Gila River',
'AZ - Havasupai',
'AZ - Hopi',
'AZ - Hualapai',
'AZ - Kaibab',
'AZ - Navajo',
'AZ - Pascua Yaqui',
'AZ - Quechan',
'AZ - Salt River',
'AZ - San Carlos',
'AZ - San Juan',
'AZ - Tohono O\'odham',
'AZ - Tonto Apache',
'AZ - White Mountain',
'AZ - Yavapai-Apache',
'AZ - Yavapai-Prescott',
'CA - Agua Caliente',
'CA - Alturas',
'CA - Augustine',
'CA - Bear River',
'CA - Benton',
'CA - Berry Creek',
'CA - Big Lagoon',
'CA - Big Pine',
'CA - Big Sandy',
'CA - Big Valley Rancheria',
'CA - Bishop Paiute',
'CA - Blue Lake',
'CA - Bridgeport Indian Colony',
'CA - Buena Vista Rancheria',
'CA - Cabazon',
'CA - Cachil DeHe',
'CA - Cahto',
'CA - Cahuilla',
'CA - California Valley',
'CA - Campo',
'CA - Capitan Grande',
'CA - Cedarville',
'CA - Chemehuevi',
'CA - Cher-Ae Heights',
'CA - Chicken Ranch',
'CA - Cloverdale',
'CA - Cold Springs',
'CA - Cortina',
'CA - Coyote Valley',
'CA - Dry Creek',
'CA - Elem',
'CA - Elk Valley',
'CA - Enterprise',
'CA - Ewiiaapaayp',
'CA - Federated Indians of Graton',
'CA - Fort Bidwell',
'CA - Fort Independence',
'CA - Fort Mojave',
'CA - Greenville',
'CA - Grindstone',
'CA - Guidiville',
'CA - Habematolel',
'CA - Hoopa',
'CA - Hopland',
'CA - Iipay',
'CA - Inaja',
'CA - Ione',
'CA - Jackson',
'CA - Jamul',
'CA - Karuk',
'CA - Kashia',
'CA - Koi',
'CA - La Jolla',
'CA - La Posta',
'CA - Lone Pine',
'CA - Los Coyotes',
'CA - Lytton',
'CA - Manchester',
'CA - Manzanita',
'CA - Mechoopda',
'CA - Mesa Grande',
'CA - Middletown',
'CA - Mooretown',
'CA - Morongo',
'CA - North Fork',
'CA - Pala',
'CA - Paskenta',
'CA - Pauma',
'CA - Pechanga',
'CA - Picayune',
'CA - Pinoleville',
'CA - Pit River',
'CA - Potter Valley',
'CA - Quartz Valley',
'CA - Ramona',
'CA - Redding',
'CA - Redwood Valley',
'CA - Resighini',
'CA - Rincon',
'CA - Robinson',
'CA - Round Valley',
'CA - San Manuel',
'CA - San Pasqual',
'CA - Santa Rosa',
'CA - Santa Rosa of Cahuilla',
'CA - Santa Ynez',
'CA - Scotts Valley',
'CA - Sherwood Valley',
'CA - Shingle Springs',
'CA - Soboba',
'CA - Susanville',
'CA - Sycuan',
'CA - Table Mountain',
'CA - Tejon',
'CA - Timbi-sha Shoshone',
'CA - Tolowa Dee-Ni\'',
'CA - Torres Martinez',
'CA - Tule River',
'CA - Tuolumne',
'CA - Twenty-Nine Palms',
'CA - United Auburn',
'CA - Viejas',
'CA - Wilton',
'CA - Wiyot',
'CA - Yocha Dehe',
'CA - Yurok',
'CO - Southern Ute',
'CO - Ute Mountain Ute',
'CT - Mashantucket Pequot',
'CT - Mohegan',
'FL - Miccosukee',
'FL - Seminole',
'IA - Sac & Fox of Mississippi',
'ID - Coeur D\'Alene',
'ID - Kootenai',
'ID - Nez Perce',
'ID - Shoshone-Bannock',
'KS - Iowa of Kansas',
'KS - Kickapoo of Kansas',
'KS - Prairie Band',
'KS - Sac and Fox Nation of Missouri in Kansas and Nebraska',
'LA - Chitimacha',
'LA - Coushatta',
'LA - Jena',
'LA - Tunica-Biloxi',
'MA - Mashpee',
'MA - Wampanoag',
'ME - Aroostok',
'ME - Houlton',
'ME - Passamaquoddy Indian Township',
'ME - Passamaquoddy Pleasant Point',
'ME - Penobscot',
'MI - Bay Mills',
'MI - Grand Traverse',
'MI - Hannahville',
'MI - Keweenaw',
'MI - Lac Vieux',
'MI - Little River',
'MI - Little Traverse',
'MI - Match-e-be-nash-she-wish Band',
'MI - Nottawaseppi Potawatomi',
'MI - Pokagon',
'MI - Saginaw Chippewa',
'MI - Sault Ste. Marie',
'MN - Bois Forte',
'MN - Fond du Lac',
'MN - Grand Portage',
'MN - Leech Lake',
'MN - Lower Sioux',
'MN - Mille Lacs',
'MN - Minnesota Chippewa',
'MN - Prairie Island',
'MN - Red Lake',
'MN - Shakopee',
'MN - Upper Sioux',
'MN - White Earth',
'MO - Eastern Shawnee',
'MS - Mississippi Choctaw',
'MT - Assiniboine and Gros Ventre Tribes',
'MT - Assiniboine and Sioux',
'MT - Blackfeet',
'MT - Chippewa-Cree',
'MT - Confederated Salish',
'MT - Crow',
'MT - Little Shell Tribe',
'MT - Northern Cheyenne',
'NC - Eastern Cherokee',
'ND - Spirit Lake',
'ND - Standing Rock',
'ND - Three Affiliated',
'ND - Turtle Mountain',
'NE - Omaha',
'NE - Ponca of Nebraska',
'NE - Santee Sioux',
'NE - Winnebago',
'NM - Jicarilla',
'NM - Mescalero Apache',
'NM - Ohkay Owingeh',
'NM - Pueblo of Acoma',
'NM - Pueblo of Cochiti',
'NM - Pueblo of Isleta',
'NM - Pueblo of Jemez',
'NM - Pueblo of Laguna',
'NM - Pueblo of Nambe',
'NM - Pueblo of Picuris',
'NM - Pueblo of Pojoaque',
'NM - Pueblo of San Felipe',
'NM - Pueblo of San Ildefonso',
'NM - Pueblo of Sandia',
'NM - Pueblo of Santa Ana',
'NM - Pueblo of Santa Clara',
'NM - Pueblo of Taos',
'NM - Pueblo of Tesuque',
'NM - Pueblo of Zia',
'NM - Pueblo of Zuni',
'NM - Ramah Navajo Chapter',
'NM - Santo Domingo',
'NV - Duckwater',
'NV - Ely Shoshone',
'NV - Fort McDermitt',
'NV - Las Vegas',
'NV - Lovelock',
'NV - Moapa',
'NV - Paiute-Shoshone',
'NV - Pyramid Lake',
'NV - Reno-Sparks',
'NV - Shoshone-Paiute',
'NV - Summit Lake',
'NV - Te-Moak',
'NV - Walker River',
'NV - Washoe',
'NV - Winnemucca',
'NV - Yerington',
'NV - Yomba Shoshone',
'NY - Cayuga Nation of New York',
'NY - Oneida Indian Nation',
'NY - Onondaga',
'NY - Saint Regis',
'NY - Seneca',
'NY - Shinnecock',
'NY - Tonawanda',
'NY - Tuscarora',
'OK - Absentee-Shawnee',
'OK - Alabama-Quassarte',
'OK - Apache',
'OK - Caddo',
'OK - Cherokee',
'OK - Chickasaw',
'OK - Choctaw',
'OK - Citizen Potawatomi',
'OK - Comanche',
'OK - Delaware Nation',
'OK - Delaware Tribe',
'OK - Fort Sill',
'OK - Iowa of Oklahoma',
'OK - Kaw',
'OK - Kialegee',
'OK - Kickapoo of Oklahoma',
'OK - Kiowa',
'OK - Miami of Oklahoma',
'OK - Modoc',
'OK - Muscogee (Creek) Nation',
'OK - Osage Nation',
'OK - Otoe-Missouria',
'OK - Ottawa of Oklahoma',
'OK - Pawnee',
'OK - Peoria',
'OK - Ponca of Oklahoma',
'OK - Quapaw Nation',
'OK - Sac and Fox Nation, Oklahoma',
'OK - Seminole Nation of Oklahoma',
'OK - Seneca-Cayuga Nation',
'OK - Shawnee',
'OK - Thlopthlocco Tribal Town',
'OK - Tonkawa',
'OK - United Keetoowah',
'OK - Wichita',
'OK - Wyandotte',
'OK – Cheyenne and Arapaho Tribes',
'OR - Burns Paiute',
'OR - Confederated Coos',
'OR - Coquille',
'OR - Cow Creek',
'OR - Grand Ronde Tribes',
'OR - Klamath',
'OR - Siletz Tribe',
'OR - Umatilla Tribe',
'OR - Warms Springs Tribe',
'RI - Narragansett',
'SC - Catawba',
'SD - Cheyenne River Sioux Tribe',
'SD - Crow Creek',
'SD - Flandreau',
'SD - Lower Brule',
'SD - Oglala Sioux',
'SD - Rosebud',
'SD - Sisseton-Wahpeton',
'SD - Yankton',
'TX - Alabama-Coushatta',
'TX - Kickapoo of Texas',
'TX - Ysleta Del Sur',
'UT - Confederated Goshute',
'UT - Northwestern Shoshone',
'UT - Paiute of Utah',
'UT - Skull Valley',
'UT - Ute',
'VA - Chickahominy Indian Tribe - Eastern Division',
'VA - Chickahominy Indian Tribe, Inc.',
'VA - Monacan Indian Nation',
'VA - Nansemond Indian Tribe',
'VA - Pamunkey Indian Tribe',
'VA - Rappahannock Tribe, Inc.',
'VA - Upper Mattaponi Tribe',
'WA - Chehalis',
'WA - Confederated Colville',
'WA - Confederated Yakama',
'WA - Cowlitz',
'WA - Hoh',
'WA - Jamestown',
'WA - Kalispel',
'WA - Lower Elwha',
'WA - Lummi',
'WA - Makah',
'WA - Muckleshoot',
'WA - Nisqually',
'WA - Nooksack',
'WA - Port Gamble',
'WA - Puyallup',
'WA - Quileute',
'WA - Quinault',
'WA - Samish',
'WA - Sauk-Suiattle',
'WA - Shoalwater',
'WA - Skokomish',
'WA - Snoqualmie',
'WA - Spokane',
'WA - Squaxin',
'WA - Stillaguamish',
'WA - Suquamish',
'WA - Swinomish',
'WA - Tulalip',
'WA - Upper Skagit',
'WI - Bad River Band',
'WI - Forest County',
'WI - Ho-Chunk',
'WI - Lac Courte Oreilles',
'WI - Lac du Flambeau',
'WI - Menominee',
'WI - Oneida Nation (Wisconsin)',
'WI - Red Cliff',
'WI - Sokaogon',
'WI - St. Croix',
'WI - Stockbridge',
'WY - Eastern Shoshone',
'WY - Northern Arapaho',
]
export const csuCountry = [
  'United States of America',
  'Afghanistan',
  'Aland Islands',
  'Albania',
  'Algeria',
  'American Samoa',
  'Andorra',
  'Angola',
  'Anguilla',
  'Antartica',
  'Antigua and Barbuda',
  'Argentina',
  'Armenia',
  'Aruba',
  'Australia',
  'Austria',
  'Azerbaijan',
  'Bahamas, The',
  'Bahrain',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Belgium',
  'Belize',
  'Benin',
  'Bermuda',
  'Bhutan',
  'Bolivia (Plurinational State of)',
  'Bonaire, Saint Eustatius and Saba',
  'Bosnia and Herzegovina',
  'Botswana',
  'Bouvet Island',
  'Brazil',
  'British Indian Ocean Territory (the)',
  'Brunei Darussalam',
  'Bulgaria',
  'Burkina Faso',
  'Burundi',
  'Cabo Verde',
  'Cambodia',
  'Cameroon',
  'Canada',
  'Cayman Islands (the)',
  'Central African Republic',
  'Chad',
  'Chile',
  'China',
  'Christmas Island',
  'Cocos (Keeling) Islands (the)',
  'Colombia',
  'Comoros',
  'Congo (the Democratic Republic of the )',
  'Congo (the)',
  'Cook Islands (the)',
  'Costa Rica',
  `Côte d'Ivoire`,
  'Croatia',
  'Cuba',
  'Curacao',
  'Cyprus',
  'Czechia',
  'Denmark',
  'Djibouti',
  'Dominica',
  'Dominican Republic',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'Equatorial Guinea',
  'Eritrea',
  'Estonia',
  'Ethiopia',
  'Falkland Islands (the) [Malvinas]',
  'Faroe Islands (the)',
  'Fiji',
  'Finland',
  'France',
  'French Guiana',
  'French Polynesia',
  'French Southern Territories (the)',
  'Gabon',
  'Gambia, The',
  'Georgia',
  'Germany',
  'Ghana',
  'Gibraltar',
  'Greece',
  'Greenland',
  'Grenada',
  'Guadeloupe',
  'Guam',
  'Guatemala',
  'Guernsey',
  'Guinea',
  'Guinea-Bissau',
  'Guyana',
  'Haiti',
  'Heard Island and McDonald Islands',
  'Holy See',
  'Honduras',
  'Hong Kong',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  'Iran (Islamic Republic of)',
  'Iraq',
  'Ireland',
  'Isle of Man',
  'Israel',
  'Italy',
  'Jamaica',
  'Japan',
  'Jersey',
  'Jordan',
  'Kazakhstan',
  'Kenya',
  'Kiribati',
  `Korea (the Democratic People's Republic of)`,
  'Korea (the Republic of)',
  'Kuwait',
  'Kyrgyzstan',
  `Lao People's Democratic Republic (the)`,
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libya',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Macao',
  'Madagascar',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Marshall Islands',
  'Martinique',
  'Mauritania',
  'Mauritius',
  'Mayotte',
  'Mexico',
  'Micronesia, Federated States of',
  'Moldova (the Republic of)',
  'Monaco',
  'Mongolia',
  'Montenegro',
  'Montserrat',
  'Morocco',
  'Mozambique',
  'Myanmar',
  'Namibia',
  'Nauru',
  'Nepal',
  'Netherlands',
  'New Caledonia',
  'New Zealand',
  'Nicaragua',
  'Niger',
  'Nigeria',
  'Niue',
  'Norfolk Island',
  'North Macedonia',
  'Northern Mariana Islands (the)',
  'Norway',
  'Oman',
  'Pakistan',
  'Palau',
  'Palestine, State of',
  'Panama',
  'Papua New Guinea',
  'Paraguay',
  'Peru',
  'Philippines',
  'Pitcairn',
  'Poland',
  'Portugal',
  'Puerto Rico',
  'Qatar',
  'Reunion',
  'Romania',
  'Russian Federation (the)',
  'Rwanda',
  'Saint Barthelemy',
  'Saint Helena, Ascension and Tristan da Cunha',
  'Saint Kitts and Nevis',
  'Saint Lucia',
  'Saint Martin (French part)',
  'Saint Pierre and Miquelon',
  'Saint Vincent and the Grenadines',
  'Samoa',
  'San Marino',
  'Sao Tome & Principe',
  'Saudi Arabia',
  'Senegal',
  'Serbia',
  'Seychelles',
  'Sierra Leone',
  'Singapore',
  'Sint Maarten (Dutch Part)',
  'Slovakia',
  'Slovenia',
  'Solomon Islands',
  'Somalia',
  'South Africa',
  'South Georgia And The South Sandwich Islands',
  'South Sudan',
  'Spain',
  'Sri Lanka',
  'Sudan',
  'Suriname',
  'Svalbard And Jan Mayen',
  'Sweden',
  'Switzerland',
  'Syrian Arab Republic',
  'Taiwan',
  'Tajikistan',
  'Tanzania, United Republic of',
  'Thailand',
  'Timor-Leste',
  'Togo',
  'Tokelau',
  'Tonga',
  'Trinidad and Tobago',
  'Tunisia',
  'Turkey',
  'Turkmenistan',
  'Turks and Caicos Islands (the)',
  'Tuvalu',
  'Uganda',
  'Ukraine',
  'United Arab Emirates',
  'United Kingdom of Great Britain and Northern Ireland (the)',
  'United States Minor Outlying Islands (the)',
  'Uruguay',
  'Uzbekistan',
  'Vanuatu',
  'Venezuela (Bolivian Republic of)',
  'Viet Nam',
  'Virgin Islands (British)',
  'Virgin Islands (U.S.)',
  'Wallis and Futuna',
  'Western Sahara',
  'Yemen',
  'Zambia',
  'Zimbabwe',
];

export const notUsCountry = [
  "Country name*",
  "Afghanistan",
  "Albania",
  "Algeria",
  "Andorra",
  "Angola",
  "Anguilla",
  "Antigua & Barbuda",
  "Argentina",
  "Armenia",
  "Aruba",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Azores Islands",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bermuda",
  "Bhutan",
  "Bolivia",
  "Bosnia-Herzegovina",
  "Botswana",
  "Brazil",
  "British Virgin Islands",
  "Brunei",
  "Bulgaria",
  "Burkina Faso (Upper Volta)",
  "Burundi",
  "Cabo Verde",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Cayman Islands",
  "Central African Republic",
  "Chad",
  "Channel Islands",
  "Chile",
  "China, Peoples Republic of",
  "Cocos Islands",
  "Colombia",
  "Comoros",
  "Congo, Democratic Rep. of the",
  "Congo, Republic of the",
  "Cook Islands",
  "Costa Rica",
  "Cote D Ivoire",
  "Croatia",
  "Cuba",
  "Curacao",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Eswatini (formerly Swaziland)",
  "Ethiopia",
  "Falkland Islands",
  "Fiji",
  "Finland",
  "France",
  "French Guiana",
  "French Polynesia",
  "Gabon",
  "Gambia",
  "Georgia (Republic Of)",
  "Germany, Fed Republic",
  "Ghana",
  "Gibraltar",
  "Greece",
  "Greenland",
  "Grenada",
  "Guadeloupe",
  "Guatemala",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Honduras",
  "Hong Kong",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Isle Of Man",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Korea, Dem Republic (North)",
  "Korea, Repub. Of (South)",
  "Kosovo",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macao",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Martinique",
  "Mauritania",
  "Mauritius",
  "Mexico",
  "Micronesia",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Montserrat",
  "Morocco",
  "Mozambique",
  "Myanmar, Union Of (Burma)",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "New Caledonia",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "Niue",
  "North Macedonia, Republic of",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestinian Territories",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Pitcairn Island",
  "Poland",
  "Portugal",
  "Qatar",
  "Reunion",
  "Romania",
  "Russia",
  "Rwanda",
  "Samoa (formerly Western Samoa)",
  "San Marino",
  "Sao Tome & Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles Islands",
  "Sierra Leone",
  "Singapore",
  "Sint Maarten",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "St Vincent & The Grenadines",
  "St. Helena",
  "St. Kitts & Nevis",
  "St. Lucia",
  "St. Pierre & Miquelon",
  "Sudan",
  "Suriname",
  "Sweden",
  "Switzerland",
  "Syria",
  "Tahiti",
  "Taiwan (Rep. Of China)",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tonga",
  "Trinidad & Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Turks & Caicos Islands",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Venezuela",
  "Vietnam",
  "Wallis & Futuma Islands",
  "Western Sahara",
  "Yemen",
  "Zambia",
  "Zimbabwe",
  "Other"
]
export const highSchoolType = [
  { name: 'Public', value: 'Public' },
  { name: 'Charter', value: 'Charter' },
  { name: 'Home School', value: 'Home School' },
  { name: 'Religious', value: 'Religious' },
  { name: 'Independent', value: 'Independent' },
];

export const collegeCourseMapSubjectArea = {
  'A': ['Civics/American Government', 'U.S. History',
    'World History/Cultures/Hist. Geography'],
  'B': ['English', 'English-ESL/ELD'],
  'C': ['Additional Math','Algebra I', 'Algebra II', 'Algebra II/Trigonometry',
    'Calculus', 'Computer Science', 'Geometry',
    'Mathematics I','Mathematics II', 'Mathematics III',
    'Mathematics I (Integrated)', 'Mathematics II (Integrated)','Mathematics III (Integrated)', 
    'Other Advanced Mathematics', 'Pre-Calculus', 'Statistics'],
  'D1': ['Biology/Life Sciences', 'Biology/Earth & Space Sciences'],
  'D2': ['Chemistry',
    'Chemistry/Earth & Space Sciences',
    'Physics',
    'Physics/Earth & Space Sciences',
    'Integrated Science 1',
    'Integrated Science 2',
    'Integrated Science 3',
    'Applied Science',
    'Computer Science',
    'Earth & Space Sciences',
    'Engineering',
    'Interdisciplinary Sciences'],
  'E': ['Yr 1 Other Than English',
    'Yr 2 Other Than English',
    'Yr 3 Other Than English',
    'Yr 4+ Other Than English'],
    'F': ['Dance ',
    'Music',
    'Theater',
    'Visual Arts',
    'Interdisciplinary',
    'Interdisciplinary Arts'],
  'G': ['Elective - English',
    'Elective - ESL/ELD',
    'Elective - History/Social Science',
    'Elective - Interdisciplinary',
    'Elective - Language Other than English',
    'Elective - Mathematics',
    'Elective - Math-Computer Science',
    'Elective - Science-Biology/Life Sciences',
    'Elective - Science-Integrated Science',
    'Elective - Science-Physical Science',
    'Elective - Visual & Performing Arts'],
}


export const catName = (firstName: string, midName: string, lastName: string) => {
  var s2 = midName ?? '' ? ' ' + (midName ?? '') + ' ' : ' ';
  return (firstName ?? '') + s2 + (lastName ?? '');
};

export const toTitleCase = (str: string) => {
  return str.replace(/\w\S*/g, function (s: string) {
    return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
  });
};

export const toLocalShortDate = (d: Date) => {
  return new Intl.DateTimeFormat(Intl.DateTimeFormat().resolvedOptions().locale).format(d);
};

export const removeIntercomeCache = () => {

  // Xóa Cookie liên quan đến Intercom
  document.cookie.split(";").forEach((cookie) => {
    const cookieName = cookie.split("=")[0].trim();
    if (cookieName.startsWith("intercom-")) {
      // Xóa cookie bằng cách đặt giá trị rỗng và ngày hết hạn trong quá khứ
      document.cookie = cookieName + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
      // Xóa cookie với tất cả các đường dẫn có thể
      document.cookie = cookieName + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=" + window.location.hostname;
    }
  });


  // Xóa Local Storage liên quan đến Intercom
  Object.keys(localStorage).forEach((key) => {
    if (key.startsWith('intercom-')) {
      localStorage.removeItem(key);
    }
  });

  // Xóa Session Storage liên quan đến Intercom
  Object.keys(sessionStorage).forEach((key) => {
    if (key.startsWith('intercom-')) {
      sessionStorage.removeItem(key);
    }
  });
};


export const formatBooleanToYesNo = (value: any): string => {
    if (value === true || value === 'true') return 'Yes';
    if (value === false || value === 'false') return 'No';
    return value || '-';
  };